import { render } from "./VvBannerCarousel.vue?vue&type=template&id=75655bd8&scoped=true"
import script from "./VvBannerCarousel.vue?vue&type=script&lang=js"
export * from "./VvBannerCarousel.vue?vue&type=script&lang=js"

import "./VvBannerCarousel.vue?vue&type=style&index=0&id=75655bd8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75655bd8"]])

export default __exports__